<template>
    <core-view class="flex-column" fill-height>
        <v-overlay v-show="syncsAtivos > 0 || ((progresso !== 100) && (totalItem > minimoParaLoading)) || primeiroUpdate">
            <v-snackbar timeout="2000000" v-if="primeiroUpdate" v-model="alwaysTrue">
              <p>Trazendo dados pela primeira vez...</p>
            </v-snackbar>
            <v-snackbar timeout="2000000" v-model="snackbar" v-else-if="totalItem > minimoParaLoading">
                <p>Grande número de itens para atualizar, aguarde...</p>
                <p>{{ itemsProcessados }} de {{ totalItem }}</p>
                <v-progress-linear color="primary" :value="progresso"></v-progress-linear>
            </v-snackbar>
            <v-snackbar timeout="2000000" v-model="snackbar" v-else>
                <p>Sincronizando dados...</p>
                <v-progress-linear color="primary" indeterminate></v-progress-linear>
            </v-snackbar>
        </v-overlay>

        <v-snackbar
          v-if="totalItem > 10"
          color="primary"
          timeout="6000"
          v-model="snackbarSucesso"
        >
          <v-icon class="snackbar__icon">
            mdi-check-circle
          </v-icon>
          Dados atualizados com sucesso!
        </v-snackbar>

        <div>
          <dialog-troca-senha>
          </dialog-troca-senha>
        </div>
    </core-view>
</template>

<script>
import { mapActions, mapState } from 'vuex';

// import errorHandler from '@/utils/error-handler';

import CoreView from '@/components/core/view/Index.vue';

import DialogTrocaSenha from '@/components/core/dialog-troca-senha/Index.vue';

import db from '@/plugins/dexie';
import { SetupEnvioLocal } from '@/utils/atualizalocal';
import { TOKEN, USER_STORAGE } from '@/constants/STORAGE';
import { SetupWebSocket } from '../../utils/ws/websocket';

export default {
  name: 'ViewHome',

  components: {
    CoreView,
    DialogTrocaSenha,
  },

  data() {
    return {
      snackbar: true,
      snackbarSucesso: false,
      alwaysTrue: true,
      formatado: [],
      wsConnection: null,
      websocket: {
        connectionId: null,
        primeiraconexao: true,
        conectado: false,
      },
      online: false,
    };
  },

  computed: {
    ...mapState('atualizalocal', [
      'totalItem',
      'itemsProcessados',
      'progresso',
      'minimoParaLoading',
      'estaAdicionado',
      'estaAtualizado',
      'primeiroUpdate',
      'syncsAtivos',
    ]),
  },

  watch: {
    progresso(valor) {
      if (valor === 100) {
        this.snackbarSucesso = true;
        this.$_primeiroUpdate(false);
      }
    },
    primeiroUpdate(valor) {
      if (valor) {
        setTimeout(() => {
          if (valor) {
            console.log('Está demorando mais que o normal!');
          }
        }, 5000);
      }
    },
  },

  methods: {
    ...mapActions({
      $_recebimentosFind: 'recebimento/find',
      $_findFila: 'fila/find',
      $_updateWebPushUser: 'webpush/updateUserId',
      $_findUserId: 'users/findByWebId',
      $_primeiroUpdate: 'cache/primeiroUpdate',
    }),

    getSessionStorage(key, defaultValue) {
      return sessionStorage.getItem(key) ?? defaultValue;
    },

    async $_setupIdUsuario() {
      try {
        const tokenString = this.getSessionStorage(TOKEN, '');
        if (!tokenString) return;
        const token = JSON.parse(tokenString);
        if (token.userId) {
          const data = await this.$_findUserId({ id: token.userId });
          if (data?.useidusuario) {
            sessionStorage.setItem(USER_STORAGE.useidusuario, data.useidusuario);
          }
        }
      } catch (err) {
        console.warn('Erro ao configurar useidusuario:', err);
      }
    },

    /* eslint-disable-next-line consistent-return */
    async SetupWebPushToken() {
      const token = sessionStorage.getItem('auth:token');
      const item = await db.worker.get({ id: 1 });
      setTimeout(() => {
        db.worker.put({
          ...item,
          id: 1,
          wortoken: token,
        });
      }, 250);
      const key = (await db.worker.get({ id: 1 }))?.worpushkey;
      console.log(token, 'sub');
      if (key) {
        const resposta = await this.$_updateWebPushUser({
          key,
          userid: (JSON.parse(token)).userId,
        });
        console.log(resposta);
      } else {
        console.log('No active subscription found.');
        return null;
      }
    },
  },

  async created() {
    SetupWebSocket();
    this.SetupWebPushToken();
    this.$_setupIdUsuario();
    await SetupEnvioLocal({ aguardarLock: true });
  },
};
</script>

<style scoped>
  .v-sheet--offset {
    top: 5px;
    position: relative;
  }

  .center {
    width: 100%;
    text-align: center;
  }

  .snackbar__icon {
    margin-right: 15px;
  }
</style>
